import { render, staticRenderFns } from "./ApplicantFormMns.vue?vue&type=template&id=776483c6&scoped=true&"
import script from "./ApplicantFormMns.vue?vue&type=script&lang=js&"
export * from "./ApplicantFormMns.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantFormMns.vue?vue&type=style&index=0&id=776483c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776483c6",
  null
  
)

export default component.exports